import { render, staticRenderFns } from "./TransferContacts.vue?vue&type=template&id=7d0207f3&scoped=true"
import script from "./TransferContacts.vue?vue&type=script&lang=js"
export * from "./TransferContacts.vue?vue&type=script&lang=js"
import style0 from "./TransferContacts.vue?vue&type=style&index=0&id=7d0207f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0207f3",
  null
  
)

export default component.exports